import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledWarning: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_warning"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="warning icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M12.038 5.20746C12.8982 3.67824 15.0999 3.67825 15.9601 5.20746L24.6453 20.6479C25.489 22.1477 24.4051 24.001 22.6843 24.001H5.31382C3.59296 24.001 2.50911 22.1477 3.35278 20.6479L12.038 5.20746ZM14 10.551C13.5858 10.551 13.25 10.8867 13.25 11.301V16.301C13.25 16.7152 13.5858 17.051 14 17.051C14.4142 17.051 14.75 16.7152 14.75 16.301V11.301C14.75 10.8867 14.4142 10.551 14 10.551ZM15 19.551C15 18.9987 14.5523 18.551 14 18.551C13.4477 18.551 13 18.9987 13 19.551C13 20.1032 13.4477 20.551 14 20.551C14.5523 20.551 15 20.1032 15 19.551Z" />
      </svg>
    </span>
  );
};

export { FilledWarning };
